import { useEffect, useState } from 'react';
import { AdminAccessRequired } from '../components/users/AdminAccessRequired';
import { listCleanupReports } from '../services/adminService';

export const ReportsPage = ({ currentUser }) => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (currentUser.role !== 'admin') {
      return;
    }

    listCleanupReports()
      .then(setReports)
      .catch((reportError) => setError(reportError.message))
      .finally(() => setLoading(false));
  }, [currentUser.role]);

  if (currentUser.role !== 'admin') {
    return <AdminAccessRequired />;
  }

  return (
    <div className="px-3 pb-3">
      <div className="card border-0 p-4">
        <div className="d-flex align-items-center justify-content-between gap-3">
          <div>
            <span className="users-eyebrow">Automation</span>
            <h4 className="m-0">Cleanup Reports</h4>
          </div>
          <i className="bi bi-clipboard-data fs-2 text-success" />
        </div>
      </div>

      {loading && <div className="card border-0 p-4 mt-3 text-center">Loading reports...</div>}
      {error && <div className="alert alert-danger mt-3">{error}</div>}

      {!loading && !error && (
        <div className="d-grid gap-3 mt-3">
          {reports.length ? reports.map((report) => (
            <ReportCard key={report.id} report={report} />
          )) : (
            <div className="card border-0 p-4 text-center">No cleanup reports yet.</div>
          )}
        </div>
      )}
    </div>
  );
}

const ReportCard = ({ report }) => (
  <article className="card border-0 p-3">
    <div className="d-flex align-items-start justify-content-between gap-3">
      <div>
        <span className="users-eyebrow">{report.taskId}</span>
        <h5 className="m-0">{report.taskName}</h5>
        <p className="m-0 text-muted">{formatDate(report.finishedAt)}</p>
      </div>
      <span className={report.status === 'success' ? 'badge bg-green' : 'badge bg-danger'}>
        {report.status}
      </span>
    </div>

    <div className="row g-2 mt-2">
      {Object.entries(report.metrics).map(([key, value]) => (
        <div className="col-12 col-sm-6 col-lg-3" key={key}>
          <div className="bg-light rounded p-3 h-100">
            <span className="users-eyebrow">{formatMetricLabel(key)}</span>
            <strong>{String(value)}</strong>
          </div>
        </div>
      ))}
    </div>

    {report.errorMessage && <p className="alert alert-danger m-0 mt-3">{report.errorMessage}</p>}
  </article>
);

function formatDate(value) {
  return new Date(value).toLocaleString();
}

function formatMetricLabel(value) {
  return value.replace(/([A-Z])/g, ' $1').trim();
}
